import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Briefcase } from "lucide-react";
import { TEAM_DOCTORS } from "@/data/static";

export default function MeetTheTeam() {
  return (
    <section className="section bg-slate-50" data-testid="team-section">
      <div className="container-x">
        <motion.div initial={{opacity:0,y:20}} whileInView={{opacity:1,y:0}} viewport={{once:true,margin:"-80px"}} transition={{duration:0.6}} className="max-w-2xl">
          <span className="overline">Meet Our Doctors</span>
          <h2 className="font-heading mt-4 text-4xl sm:text-5xl tracking-tight font-medium">A team you can <em className="italic font-light text-primary">trust</em>.</h2>
          <p className="mt-4 text-slate-600">Experienced specialists at Aastha Maternity & Ortho Care Centre, Sasaram — dedicated to compassionate, evidence-based care.</p>
        </motion.div>
        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {TEAM_DOCTORS.map((d,i)=>(
            <motion.div key={d.id} initial={{opacity:0,y:24}} whileInView={{opacity:1,y:0}} viewport={{once:true,margin:"-60px"}} transition={{duration:0.5,delay:i*0.08}}
              className="group bg-white rounded-3xl overflow-hidden border border-slate-100 shadow-soft hover:shadow-medium transition-all"
              data-testid={`team-card-${d.id}`}>
              <div className="aspect-[4/5] overflow-hidden bg-slate-100">
                <img src={d.photo} alt={d.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"/>
              </div>
              <div className="p-6">
                <div className="font-heading text-xl font-medium text-slate-900">{d.name}</div>
                <div className="text-sm text-primary mt-1">{d.role}</div>
                <div className="mt-4 space-y-2 text-sm text-slate-600">
                  <div className="flex gap-2"><GraduationCap className="w-4 h-4 text-primary mt-0.5 shrink-0"/><span>{d.qualifications}</span></div>
                  <div className="flex gap-2"><Briefcase className="w-4 h-4 text-primary mt-0.5 shrink-0"/><span>{d.experience}</span></div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
